export default {
  set (state, welcomePageFrom) {
    state.welcomePageFrom = welcomePageFrom
  }
}
